/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Plan_Session_TitleInputs */

const en_us2_plan_session_title = /** @type {(inputs: Plan_Session_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Workout ${i?.label}`)
};

const pt_br2_plan_session_title = /** @type {(inputs: Plan_Session_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treino ${i?.label}`)
};

const es_419_plan_session_title = /** @type {(inputs: Plan_Session_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entrenamiento ${i?.label}`)
};

const pt_pt2_plan_session_title = /** @type {(inputs: Plan_Session_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treino ${i?.label}`)
};

const fr_fr2_plan_session_title = /** @type {(inputs: Plan_Session_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Séance ${i?.label}`)
};

const de_de2_plan_session_title = /** @type {(inputs: Plan_Session_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Training ${i?.label}`)
};

const it_it2_plan_session_title = /** @type {(inputs: Plan_Session_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Allenamento ${i?.label}`)
};

/**
* | output |
* | --- |
* | "Workout {label}" |
*
* @param {Plan_Session_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_session_title = /** @type {((inputs: Plan_Session_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Session_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_session_title(inputs)
	if (locale === "es-419") return es_419_plan_session_title(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_session_title(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_session_title(inputs)
	if (locale === "de-DE") return de_de2_plan_session_title(inputs)
	if (locale === "it-IT") return it_it2_plan_session_title(inputs)
	return en_us2_plan_session_title(inputs)
});
export { plan_session_title as "plan.session_title" }